import React from "react";

export const InformationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433288 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9969 7.34879 18.9423 4.80707 17.0676 2.93239C15.1929 1.0577 12.6512 0.0031277 10 0ZM10 18.1818C8.38179 18.1818 6.79992 17.702 5.45443 16.8029C4.10894 15.9039 3.06025 14.6261 2.44099 13.131C1.82173 11.636 1.6597 9.99092 1.9754 8.40381C2.29109 6.81669 3.07034 5.35883 4.21458 4.21458C5.35883 3.07033 6.81669 2.29109 8.40381 1.97539C9.99093 1.6597 11.636 1.82172 13.131 2.44099C14.6261 3.06025 15.9039 4.10893 16.8029 5.45442C17.702 6.79992 18.1818 8.38179 18.1818 10C18.1794 12.1692 17.3166 14.2489 15.7828 15.7828C14.2489 17.3166 12.1692 18.1794 10 18.1818ZM10.9091 6.36364H9.09091V4.54545H10.9091V6.36364ZM10.9091 15.4545H9.09091V8.18182H10.9091V15.4545Z"
      fill="white"
    />
  </svg>
);
